import { Box, Skeleton } from '@mui/material'
import { styles } from './style'

export function SpreadSkeleton() {
  return (
    <Box sx={styles.row} aria-label='Spread skeleton'>
      <Skeleton width={120} height={32} />
    </Box>
  )
}
